import { useState } from 'react';
import { List } from '../../types';

export const useListsState = (): [List[], (additionalLists: List[]) => void] => {
  const [lists, setLists] = useState<List[]>([]);
  const addToLists = (additionalLists: List[]) => {
    setLists((prev) => [...prev, ...additionalLists]);
  };
  return [lists, addToLists];
};
